import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { changeScreenB } from '../../../store/actions/navigation.action'
import {Avatar, CardHeader, CircularProgress, Dialog, AppBar, Toolbar, IconButton, Typography } from '@material-ui/core'
import { show } from '../../../store/actions/actions.action'
import { FaEyeSlash, FaUser, FaLaugh, FaCheck, FaPiggyBank } from 'react-icons/fa'
import { MdKeyboardBackspace } from 'react-icons/md'
import { IoLogoWhatsapp } from "react-icons/io"
import { changeScreen } from '../../../store/actions/navigation.action'
import Detail from '../transactions/detail'
import { rootUrl } from '../../../config/App'

export default function Raffle(props) {
    const dispatch = useDispatch()
    const { action, error } = useSelector(state => state.actionsReducer)
    const id = (props.uid) ? props.uid : null;

    const [isLoading, setLoading] = React.useState(true)

    const [detail, setDetail] = React.useState({
        id: null,
        open: false,
        user_id: null
    })

    const [ state, setState ] = React.useState({
        telefone: false,
        telefone2: false,
        telefone3: false,
        telefone4: false,
        telefone5: false,
    })

    React.useEffect(() => {
        dispatch(show(id)).then(() => setLoading(false))
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const handlePage = (page, user_id = null) => {
        dispatch(changeScreenB({
            open: true,
            type: page,
            props: {
                user_id: user_id
            }
        }))
    }

    const _detail = (id, user_id) => {
        setDetail({
            id: id,
            open: true,
            user_id: user_id
        })
    }

    return (
        <>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreen({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">Resultado da Ação</Typography>
                </Toolbar>
            </AppBar>

            <Dialog
                open={detail.open}
                maxWidth="sm"
				style={{width: '100%'}}
                onClose={() => setDetail({ id: null, open: false })}
                className="center"
            >   
                <Detail uid={detail.id} user_id={detail.user_id} onClose={() => setDetail({ id: null, open: false, user_id: null })}/>
            </Dialog>

            <div className="mt-5 pt-1 bg-clear min-vh-100">

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <div className="card card-body mt-3 bs-bg">
                        <div className="row">
                            {(action.ganhador) &&
                                <>

                                <label className="card-body label-custom m-0 pb-1 bs-color-b">1° prêmio</label>
                                <CardHeader 
                                    avatar={
                                        <Avatar src={rootUrl + 'img/rifa/' + action.cover.img + '?w=100&h=100&s=' + action.id} />
                                    }
                                    title={<h6 className="fw-bold m-0 bs-color-b">{action.product}</h6>}
                                    subheader={
                                        <>
                                        {(action.federal === 1 && action.concurso) &&
                                            <span className="bs-color">Concurso Loteria Federal: <span className="fw-bold text-danger">{action.concurso}</span></span>
                                        }
                                        </>
                                    } 
                                />
                                <CardHeader 
                                    avatar={
                                        <Avatar className="bg-success" sizes="large">
                                            <FaCheck />
                                        </Avatar>
                                    }
                                    title={<h3 className="fw-semibold m-0 bs-color-b">{action.extracao}</h3>}
                                    subheader={<small className="fw-bold text-success">COTA CONTEMPLADA</small>} 
                                />
                                
                                <hr className="hr-muted m-0"/>

                                <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                                <CardHeader 
                                    avatar={
                                        <Avatar className="avatar-item">
                                            <FaUser />
                                        </Avatar>
                                    }
                                    title={<h6 className="fw-bold bs-color-b">{action.ganhador.name}</h6>}
                                    subheader={
                                        <>
                                        <div className="d-flex justify-content-between">
                                            <span className="d-block pointer mb-2 bs-color" onClick={() => setState({ ...state, telefone: state.telefone ? false : true })}>
                                                {(state.telefone) ? action.ganhador.telefone : <> {action.ganhador.telefone.substring(6, -1)} <FaEyeSlash /></>}
                                            </span>
                                            
                                            <span className="me-2">
                                                <a href={'http://wa.me/55'+action.ganhador.telefone} target="_blank" rel="noopener noreferrer">
                                                    <IoLogoWhatsapp color="#24d366" size={30}/>
                                                </a>
                                            </span>
                                        </div>

                                        <span onClick={() => handlePage('shopping', action.ganhador.id)} className="pointer fw-bold text-danger">Todas compras</span>
                                        
                                        </>
                                    } 
                                />
                                <hr className="hr-muted m-0"/>
                                
                                <label className="card-body label-custom m-0 pb-1 bs-color-b">Transação</label>
                                <CardHeader
                                    onClick={() => _detail(action.ganhador_transaction.id, action.ganhador.id)}
                                    avatar={
                                        <Avatar className="avatar-item">
                                            <FaLaugh />
                                        </Avatar>
                                    }
                                    title={
                                        <div className="row">
                                            <div className="col">
                                                <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(action.ganhador_transaction.transaction_amount)}</h6>
                                            </div>
                                            <div className="col">
                                                <h6 className="fw-bold bs-color-b">Cotas: {parseInt(action.ganhador_transaction.payment_method_id).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                            </div>
                                        </div>
                                    }
                                    subheader={
                                        <>
                                        <span className="d-block bs-color">Horário: {new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(action.ganhador_transaction.updated_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(action.ganhador_transaction.updated_at))}</span>
                                        {action.ganhador_transaction_total.shopping === 1 && <span className="d-block bs-color">Compras: 1</span>}
                                        </>
                                    }
                                />

                                {action.ganhador_transaction_total.shopping > 1 &&
                                <>
                                <hr className="hr-muted m-0"/>
                                                
                                <label className="card-body label-custom m-0 pb-1 bs-color-b">Investimento</label>
                                <CardHeader
                                    className="pointer"
                                    avatar={
                                        <Avatar className="avatar-item">
                                            <FaPiggyBank />
                                        </Avatar>
                                    }
                                    title={
                                        <div className="row">
                                            <div className="col">
                                                <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(action.ganhador_transaction_total.amount)}</h6>
                                            </div>
                                            <div className="col">
                                                <h6 className="fw-bold bs-color-b">Cotas: {parseInt(action.ganhador_transaction_total.cotas).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                            </div>
                                        </div>
                                    }
                                    subheader={
                                        <>
                                        <span className="d-block bs-color">Compras: {action.ganhador_transaction_total.shopping}</span>
                                        </>
                                    }
                                />
                                </>
                                }

                                </>
                            }
                        </div>
                    </div>

                    {(action.product2) &&
                        <div className="card card-body mt-3 bs-bg">
                            <div className="row">
                            {(action.ganhador2) &&
                                <>

                                <label className="card-body label-custom m-0 pb-1 bs-color-b">2° prêmio</label>
                                <CardHeader 
                                    avatar={
                                        <Avatar src={rootUrl + 'img/rifa/' + action.cover.img + '?w=100&h=100&s=' + action.id} />
                                    }
                                    title={<h6 className="fw-bold m-0 bs-color-b">{action.product2}</h6>}
                                    subheader={
                                        <>
                                        {(action.federal === 1 && action.concurso) &&
                                            <span className="bs-color">Concurso Loteria Federal: <span className="fw-bold text-danger">{action.concurso}</span></span>
                                        }
                                        </>
                                    } 
                                />
                                <CardHeader 
                                    avatar={
                                        <Avatar className="bg-success" sizes="large">
                                            <FaCheck />
                                        </Avatar>
                                    }
                                    title={<h3 className="fw-semibold m-0 bs-color-b">{action.extracao2}</h3>}
                                    subheader={<small className="fw-bold text-success">COTA CONTEMPLADA</small>} 
                                />
                                
                                <hr className="hr-muted m-0"/>

                                <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                                <CardHeader 
                                    avatar={
                                        <Avatar className="avatar-item">
                                            <FaUser />
                                        </Avatar>
                                    }
                                    title={<h6 className="fw-bold bs-color-b">{action.ganhador2.name}</h6>}
                                    subheader={
                                        <>
                                        <div className="d-flex justify-content-between">
                                            <span className="d-block pointer mb-2 bs-color" onClick={() => setState({ ...state, telefone2: state.telefone2 ? false : true })}>
                                                {(state.telefone2) ? action.ganhador2.telefone : <> {action.ganhador2.telefone.substring(6, -1)} <FaEyeSlash /></>}
                                            </span>
                                            
                                            <span className="me-2">
                                                <a href={'http://wa.me/55'+action.ganhador2.telefone} target="_blank" rel="noopener noreferrer">
                                                    <IoLogoWhatsapp color="#24d366" size={30}/>
                                                </a>
                                            </span>
                                        </div>

                                        
                                        <span onClick={() => handlePage('shopping', action.ganhador2.id)} className="pointer fw-bold text-danger">Todas compras</span>
                                        </>
                                    } 
                                />
                                <hr className="hr-muted m-0"/>
                                
                                <label className="card-body label-custom m-0 pb-1 bs-color-b">Transação</label>
                                <CardHeader
                                    onClick={() => _detail(action.ganhador2_transaction.id, action.ganhador2.id)}
                                    avatar={
                                        <Avatar className="avatar-item">
                                            <FaLaugh />
                                        </Avatar>
                                    }
                                    title={
                                        <div className="row">
                                            <div className="col">
                                                <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(action.ganhador2_transaction.transaction_amount)}</h6>
                                            </div>
                                            <div className="col">
                                                <h6 className="fw-bold bs-color-b">Cotas: {parseInt(action.ganhador2_transaction.payment_method_id).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                            </div>
                                        </div>
                                    }
                                    subheader={
                                        <>
                                        <span className="d-block bs-color">Horário: {new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(action.ganhador2_transaction.updated_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(action.ganhador2_transaction.updated_at))}</span>
                                        {action.ganhador2_transaction_total.shopping === 1 && <span className="d-block bs-color">Compras: 1</span>}
                                        </>
                                    }
                                />

                                {action.ganhador2_transaction_total.shopping > 1 &&
                                <>

                                <hr className="hr-muted m-0"/>
                                                
                                <label className="card-body label-custom m-0 pb-1 bs-color-b">Investimento</label>
                                <CardHeader
                                    className="pointer"
                                    avatar={
                                        <Avatar className="avatar-item">
                                            <FaPiggyBank />
                                        </Avatar>
                                    }
                                    title={
                                        <div className="row">
                                            <div className="col">
                                                <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(action.ganhador2_transaction_total.amount)}</h6>
                                            </div>
                                            <div className="col">
                                                <h6 className="fw-bold bs-color-b">Cotas: {parseInt(action.ganhador2_transaction_total.cotas).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                            </div>
                                        </div>
                                    }
                                    subheader={
                                        <>
                                        <span className="d-block bs-color">Compras: {action.ganhador2_transaction_total.shopping}</span>
                                        </>
                                    }
                                />
                                </>
                                }

                                </>
                            }
                            </div>
                        </div>
                    }

                    {(action.product3) &&
                        <div className="card card-body mt-3 bs-bg">
                            <div className="row">
                                {(action.ganhador3) &&
                                    <>

                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">3° prêmio</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar src={rootUrl + 'img/rifa/' + action.cover.img + '?w=100&h=100&s=' + action.id} />
                                        }
                                        title={<h6 className="fw-bold m-0 bs-color-b">{action.product3}</h6>}
                                        subheader={
                                            <>
                                            {(action.federal === 1 && action.concurso) &&
                                                <span className="bs-color">Concurso Loteria Federal: <span className="fw-bold text-danger">{action.concurso}</span></span>
                                            }
                                            </>
                                        } 
                                    />
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="bg-success" sizes="large">
                                                <FaCheck />
                                            </Avatar>
                                        }
                                        title={<h3 className="fw-semibold m-0">{action.extracao3}</h3>}
                                        subheader={<small className="fw-bold text-success">COTA CONTEMPLADA</small>} 
                                    />
                                    
                                    <hr className="hr-muted m-0"/>
    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaUser />
                                            </Avatar>
                                        }
                                        title={<h6 className="fw-bold bs-color-b">{action.ganhador3.name}</h6>}
                                        subheader={
                                            <>
                                                <div className="d-flex justify-content-between">
                                                    <span className="d-block pointer mb-2 bs-color" onClick={() => setState({ ...state, telefone3: state.telefone3 ? false : true })}>
                                                        {(state.telefone3) ? action.ganhador3.telefone : <> {action.ganhador3.telefone.substring(6, -1)} <FaEyeSlash /></>}
                                                    </span>
                                                    
                                                    <span className="me-2">
                                                        <a href={'http://wa.me/55'+action.ganhador3.telefone} target="_blank" rel="noopener noreferrer">
                                                            <IoLogoWhatsapp color="#24d366" size={30}/>
                                                        </a>
                                                    </span>
                                                </div>

                                                <span onClick={() => handlePage('shopping', action.ganhador3.id)} className="pointer fw-bold text-danger">Todas compras</span>
                                            </>
                                        } 
                                    />
                                    <hr className="hr-muted m-0"/>
                                    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Transação</label>
                                    <CardHeader
                                        onClick={() => _detail(action.ganhador3_transaction.id, action.ganhador3.id)}
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaLaugh />
                                            </Avatar>
                                        }
                                        title={
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(action.ganhador3_transaction.transaction_amount)}</h6>
                                                </div>
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">Cotas: {parseInt(action.ganhador3_transaction.payment_method_id).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                                </div>
                                            </div>
                                        }
                                        subheader={
                                            <>
                                            <span className="d-block bs-color">Horário: {new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(action.ganhador3_transaction.updated_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(action.ganhador3_transaction.updated_at))}</span>
                                            {action.ganhador3_transaction_total.shopping === 1 && <span className="d-block bs-color">Compras: 1</span>}
                                            </>
                                        }
                                    />

                                    {action.ganhador3_transaction_total.shopping > 1 &&
                                    <>
    
                                    <hr className="hr-muted m-0"/>
                                                    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Investimento</label>
                                    <CardHeader
                                        className="pointer"
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaPiggyBank />
                                            </Avatar>
                                        }
                                        title={
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(action.ganhador3_transaction_total.amount)}</h6>
                                                </div>
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">Cotas: {parseInt(action.ganhador3_transaction_total.cotas).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                                </div>
                                            </div>
                                        }
                                        subheader={
                                            <>
                                            <span className="d-block bs-color">Compras: {action.ganhador3_transaction_total.shopping}</span>
                                            </>
                                        }
                                    />
                                    </>
                                    }
    
                                    </>
                                }
                            </div>
                        </div>
                    }

                    {(action.product4) &&
                        <div className="card card-body mt-3 bs-bg">
                            <div className="row">
                                {(action.ganhador4) &&
                                    <>

                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">4° prêmio</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar src={rootUrl + 'img/rifa/' + action.cover.img + '?w=100&h=100&s=' + action.id} />
                                        }
                                        title={<h6 className="fw-bold m-0 bs-color-b">{action.product4}</h6>}
                                        subheader={
                                            <>
                                            {(action.federal === 1 && action.concurso) &&
                                                <span className="bs-color">Concurso Loteria Federal: <span className="fw-bold text-danger">{action.concurso}</span></span>
                                            }
                                            </>
                                        } 
                                    />
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="bg-success" sizes="large">
                                                <FaCheck />
                                            </Avatar>
                                        }
                                        title={<h3 className="fw-semibold m-0 bs-color-b">{action.extracao4}</h3>}
                                        subheader={<small className="fw-bold text-success">COTA CONTEMPLADA</small>} 
                                    />
                                    
                                    <hr className="hr-muted m-0"/>
    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaUser />
                                            </Avatar>
                                        }
                                        title={<h6 className="fw-bold bs-color-b">{action.ganhador4.name}</h6>}
                                        subheader={
                                            <>
                                                <div className="d-flex justify-content-between">
                                                    <span className="d-block pointer mb-2 bs-color" onClick={() => setState({ ...state, telefone4: state.telefone4 ? false : true })}>
                                                        {(state.telefone4) ? action.ganhador4.telefone : <> {action.ganhador4.telefone.substring(6, -1)} <FaEyeSlash /></>}
                                                    </span>
                                                    
                                                    <span className="me-2">
                                                        <a href={'http://wa.me/55'+action.ganhador4.telefone} target="_blank" rel="noopener noreferrer">
                                                            <IoLogoWhatsapp color="#24d366" size={30}/>
                                                        </a>
                                                    </span>
                                                </div>

                                                <span onClick={() => handlePage('shopping', action.ganhador4.id)} className="pointer fw-bold text-danger">Todas compras</span>
                                            </>
                                        } 
                                    />
                                    <hr className="hr-muted m-0"/>
                                    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Transação</label>
                                    <CardHeader
                                        onClick={() => _detail(action.ganhador4_transaction.id, action.ganhador4.id)}
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaLaugh />
                                            </Avatar>
                                        }
                                        title={
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(action.ganhador4_transaction.transaction_amount)}</h6>
                                                </div>
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">Cotas: {parseInt(action.ganhador4_transaction.payment_method_id).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                                </div>
                                            </div>
                                        }
                                        subheader={
                                            <>
                                            <span className="d-block bs-color">Horário: {new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(action.ganhador4_transaction.updated_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(action.ganhador4_transaction.updated_at))}</span>
                                            {action.ganhador4_transaction_total.shopping === 1 && <span className="d-block bs-color">Compras: 1</span>}
                                            </>
                                        }
                                    />

                                    {action.ganhador4_transaction_total.shopping > 1 &&
                                    <>
    
                                    <hr className="hr-muted m-0"/>
                                                    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Investimento</label>
                                    <CardHeader
                                        className="pointer"
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaPiggyBank />
                                            </Avatar>
                                        }
                                        title={
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(action.ganhador4_transaction_total.amount)}</h6>
                                                </div>
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">Cotas: {parseInt(action.ganhador4_transaction_total.cotas).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                                </div>
                                            </div>
                                        }
                                        subheader={
                                            <>
                                            <span className="d-block bs-color">Compras: {action.ganhador4_transaction_total.shopping}</span>
                                            </>
                                        }
                                    />
                                    </>
                                    }
    
                                    </>
                                }
                            </div>
                        </div>
                    }

                    {(action.product5) &&
                        <div className="card card-body mt-3 bs-bg">
                            <div className="row">
                                {(action.ganhador5) &&
                                    <>

                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">5° prêmio</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar src={rootUrl + 'img/rifa/' + action.cover.img + '?w=100&h=100&s=' + action.id} />
                                        }
                                        title={<h6 className="fw-bold m-0 bs-color-b">{action.product5}</h6>}
                                        subheader={
                                            <>
                                            {(action.federal === 1 && action.concurso) &&
                                                <span className="bs-color">Concurso Loteria Federal: <span className="fw-bold text-danger">{action.concurso}</span></span>
                                            }
                                            </>
                                        } 
                                    />
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="bg-success" sizes="large">
                                                <FaCheck />
                                            </Avatar>
                                        }
                                        title={<h3 className="fw-semibold m-0 bs-color-b">{action.extracao5}</h3>}
                                        subheader={<small className="fw-bold text-success">COTA CONTEMPLADA</small>} 
                                    />
                                    
                                    <hr className="hr-muted m-0"/>
    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaUser />
                                            </Avatar>
                                        }
                                        title={<h6 className="fw-bold bs-color-b">{action.ganhador5.name}</h6>}
                                        subheader={
                                            <>
                                                <div className="d-flex justify-content-between">
                                                    <span className="d-block pointer mb-2 bs-color" onClick={() => setState({ ...state, telefone5: state.telefone5 ? false : true })}>
                                                        {(state.telefone5) ? action.ganhador5.telefone : <> {action.ganhador5.telefone.substring(6, -1)} <FaEyeSlash /></>}
                                                    </span>
                                                    
                                                    <span className="me-2">
                                                        <a href={'http://wa.me/55'+action.ganhador5.telefone} target="_blank" rel="noopener noreferrer">
                                                            <IoLogoWhatsapp color="#24d366" size={30}/>
                                                        </a>
                                                    </span>
                                                </div>

                                                <span onClick={() => handlePage('shopping', action.ganhador5.id)} className="pointer fw-bold text-danger">Todas compras</span>
                                            </>
                                        } 
                                    />
                                    <hr className="hr-muted m-0"/>
                                    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Transação</label>
                                    <CardHeader
                                        onClick={() => _detail(action.ganhador5_transaction.id, action.ganhador5.id)}
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaLaugh />
                                            </Avatar>
                                        }
                                        title={
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(action.ganhador5_transaction.transaction_amount)}</h6>
                                                </div>
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">Cotas: {parseInt(action.ganhador5_transaction.payment_method_id).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                                </div>
                                            </div>
                                        }
                                        subheader={
                                            <>
                                            <span className="d-block bs-color">Horário: {new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(action.ganhador5_transaction.updated_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(action.ganhador5_transaction.updated_at))}</span>
                                            {action.ganhador5_transaction_total.shopping === 1 && <span className="d-block bs-color">Compras: 1</span>}
                                            </>
                                        }
                                    />

                                    {action.ganhador5_transaction_total.shopping > 1 &&
                                    <>
                                    <hr className="hr-muted m-0"/>
                                                    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Investimento</label>
                                    <CardHeader
                                        className="pointer"
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaPiggyBank />
                                            </Avatar>
                                        }
                                        title={
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(action.ganhador5_transaction_total.amount)}</h6>
                                                </div>
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">Cotas: {parseInt(action.ganhador5_transaction_total.cotas).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                                </div>
                                            </div>
                                        }
                                        subheader={
                                            <>
                                            <span className="d-block bs-color">Compras: {action.ganhador5_transaction_total.shopping}</span>
                                            </>
                                        }
                                    />
                                    </>
                                    }
    
                                    </>
                                }
                            </div>
                        </div>
                    }
					
					{(action.product_mais) &&
						<div className="card card-body mt-3 bs-bg">
							<div className="row">
								{(action.ganhador_mais) &&
									<>

                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Prêmio para quem comprar mais cotas</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar src={rootUrl + 'img/rifa/' + action.cover.img + '?w=100&h=100&s=' + action.id} />
                                        }
                                        title={<h6 className="fw-bold m-0 bs-color-b">{action.product_mais}</h6>}
                                    />
                                    
                                    <hr className="hr-muted m-0"/>
    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Cliente</label>
                                    <CardHeader 
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaUser />
                                            </Avatar>
                                        }
                                        title={<h6 className="fw-bold bs-color-b">{action.ganhador_mais.name}</h6>}
                                        subheader={
                                            <>
                                                <div className="d-flex justify-content-between">
                                                    <span className="d-block pointer mb-2 bs-color" onClick={() => setState({ ...state, telefone7: state.telefone7 ? false : true })}>
                                                        {(state.telefone7) ? action.ganhador_mais.telefone : <> {action.ganhador_mais.telefone.substring(6, -1)} <FaEyeSlash /></>}
                                                    </span>
                                                    
                                                    <span className="me-2">
                                                        <a href={'http://wa.me/55'+action.ganhador_mais.telefone} target="_blank" rel="noopener noreferrer">
                                                            <IoLogoWhatsapp color="#24d366" size={30}/>
                                                        </a>
                                                    </span>
                                                </div>
                                                
                                                <span onClick={() => handlePage('shopping', action.ganhador_mais.id)} className="pointer fw-bold text-danger">Todas compras</span>
                                            </>
                                        } 
                                    />
                                    <hr className="hr-muted m-0"/>
                                                    
                                    <label className="card-body label-custom m-0 pb-1 bs-color-b">Investimento</label>
                                    <CardHeader
                                        className="pointer"
                                        avatar={
                                            <Avatar className="avatar-item">
                                                <FaPiggyBank />
                                            </Avatar>
                                        }
                                        title={
                                            <div className="row">
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(action.ganhador_mais_transaction_total.amount)}</h6>
                                                </div>
                                                <div className="col">
                                                    <h6 className="fw-bold bs-color-b">Cotas: {parseInt(action.ganhador_mais_transaction_total.cotas).toLocaleString('pt-BR', {style: 'decimal'})}</h6>
                                                </div>
                                            </div>
                                        }
                                        subheader={
                                            <>
                                            <span className="d-block bs-color">Compras: {action.ganhador_mais_transaction_total.shopping}</span>
                                            </>
                                        }
                                    />
    
                                    </>
								}
							</div>
						</div>
					}
                </>
            }
            </div>
        </>
    )
}